"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_circle_tick_fill_style_1 = __importDefault(require("./uicon.circle.tick.fill.style"));
class UiconCircleTickFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.90026 27.3146C11.0835 28.7734 13.6503 29.552 16.276 29.552C19.7959 29.5483 23.1705 28.1484 25.6595 25.6595C28.1484 23.1705 29.5483 19.7959 29.552 16.276C29.552 13.6503 28.7734 11.0835 27.3146 8.90026C25.8558 6.71703 23.7824 5.01541 21.3565 4.01058C18.9306 3.00575 16.2613 2.74284 13.686 3.2551C11.1107 3.76736 8.74515 5.03177 6.88846 6.88846C5.03178 8.74514 3.76736 11.1107 3.2551 13.686C2.74284 16.2613 3.00575 18.9306 4.01058 21.3565C5.01541 23.7824 6.71703 25.8558 8.90026 27.3146ZM14.079 20.7623C14.1579 20.7951 14.2426 20.812 14.328 20.812L14.331 20.817C14.4173 20.8159 14.5025 20.7977 14.5816 20.7634C14.6608 20.729 14.7323 20.6793 14.792 20.617L22.399 12.846L21.47 11.937L14.323 19.237L11.077 15.992L10.158 16.911L13.868 20.621C13.9284 20.6815 14.0001 20.7295 14.079 20.7623Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconCircleTickFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconCircleTickFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_circle_tick_fill_style_1.default)(UiconCircleTickFill);
//# sourceMappingURL=uicon.circle.tick.fill.js.map